// Charges (shared/charges.ts, migration 050), spread into `mutations` (shared/mutations.ts): a BOM family's charges and
// a make PO line's, each saved as a whole list in order. Implementations: server/src/mutations/charges.ts.
import { z } from "zod";
import { buildChargeInput, lineChargeInput } from "./charges.ts";
import { custom } from "./mutation-kit.ts";

export const chargeMutations = {
  /**
   * A BOM family's charges (a Shopify product's, or a local item's): the whole list, in order. Rows not in it go. Not
   * a revision's: a new price never needs a new BOM revision. Returns { charges }.
   */
  "build_charge.set": custom(
    z.object({
      item_id: z.uuid().nullable().optional(),
      shopify_product_id: z.string().min(1).nullable().optional(),
      charges: z.array(buildChargeInput).max(40),
    }),
  ),
  /**
   * A make PO line's charges for this order: the whole list, in order. The line's price becomes their total per unit
   * (a sent PO's next revision, like a price typed in); an empty list leaves the price as it is. Returns { unit_price }.
   */
  "po_line.set_charges": custom(z.object({ po_line_id: z.uuid(), charges: z.array(lineChargeInput).max(40) })),
};
